var __fast_options = __fast_options || {};
__fast_options.with_product_attributes = true;
/*yan edit*/
// __fast_options.bring_product_pdp_images = true;
// __fast_options.max_carousel_images = 2;
__fast_options.product_image_custom_class = 'fs-first-image';
__fast_options.show_carousel_marks_not_just_on_hover = true;
__fast_options.full_product_url_path_redirect = false;
/*yan edit end*/

const FS_NO_INSITU_TAG = "marketing: no-insitu";

function hasNoInsituTag(data) {
    const attributes = Array.isArray(data?.attributes) ? data.attributes : [];
    const tags = attributes.find((attr) => attr[0] === "Tag")?.[1] || [];
    return tags.some(
        (tag) => typeof tag === "string" && tag.trim().toLowerCase() === FS_NO_INSITU_TAG
    );
}

__fast_options.parseProductTitle = function (title, productData, selectedVariant) {
    const attributes = productData?.attributes || [];

    const shortTitleAttribute = attributes.find(
        (attr) => attr[0] === "Global.short title"
    );

    if (
        shortTitleAttribute &&
        Array.isArray(shortTitleAttribute[1]) &&
        shortTitleAttribute[1][0]
    ) {
        return shortTitleAttribute[1][0];
    }

    // fallback to the original title if Global.short title does not exist
    return title;
};

const NewBadges = {
    set: (product, productElement) => {
        const badgeWrapper = `<div class="fs-badges-wrapper"></div>`;

        if (productElement.querySelectorAll(".fs-badges-wrapper").length === 0) {
            productElement
                .querySelector(".image-wrapper")
                ?.insertAdjacentHTML("afterbegin", badgeWrapper);
        }

        const tags = product.tags || [];

        const badgeRules = [
            {
                label: "Natural Materials",
                className: "natural-materials",
                includeAny: [
                    "material: Cotton",
                    "material: Bamboo Silk",
                    "material: Animal Hide",
                    "material: Viscose",
                    "material: Cotton Chenille",
                    "material: Hemp",
                    "material: Jute",
                    "material: Sisal",
                    "material: Natural Latex"
                ],
                excludeAny: [
                    "material: Polypropylene",
                    "material: Polyester",
                    "material: Shrink Polyester",
                    "material: Frise Polypropylene",
                    "material: Heat Set Polypropylene",
                    "material: Microfibre Polyester",
                    "material: PET (Recycled Bottles)",
                    "material: Acrylic",
                    "material: PVC",
                    "material: Recycled Polyester"
                ]
            },
            {
                label: "Handmade",
                className: "handmade",
                includeAny: [
                    "construction: Hand Braided",
                    "construction: Hand Loomed",
                    "construction: Hand Knotted",
                    "construction: Tufted",
                    "construction: Handwoven"
                ],
                excludeAny: []
            },
            {
                label: "Wool",
                className: "wool",
                includeAny: [
                    "material: Wool"
                ],
                excludeAny: [
                    "material: Acrylic",
                    "material: Microfibre Polyester",
                    "material: Polyester Chenille",
                    "material: Polypropylene",
                    "material: Polyurethane (Foam)",
                    "material: PVC",
                    "material: Recycled Leather",
                    "material: Recycled Polyester"
                ]
            },
            {
                label: "Recycled Materials",
                className: "recycled-materials",
                includeAny: [
                    "material: Recycled Polyester",
                    "material: Recycled Leather",
                    "material: PET (Recycled Bottles)"
                ],
                excludeAny: []
            }
        ];

        badgeRules.forEach(rule => {
            const hasIncludedTag = rule.includeAny.some(tag => tags.includes(tag));
            const hasExcludedTag = rule.excludeAny.some(tag => tags.includes(tag));

            if (hasIncludedTag && !hasExcludedTag) {
                const promoLabel = NewBadges.createLabel(rule.label, rule.className);
                NewBadges.addLabel(productElement, promoLabel, rule.className);
            }
        });
    },

    createLabel: (text, className) => {
        return `
      <div 
        class="text-badge fs_product_text_badge_flag fs-badge-${className} fs-text-badge-product fs-badge-top-left svelte-1no9z77"
        style="--text-badge-font-size: 12px; --text-badge-background-color: #501008; --text-badge-border-color: transparent; --text-badge-text-color: #ffffff; --text-badge-border-radius: 0px; --text-badge-left: 0; --text-badge-right: unset; --text-badge-top: 0; --text-badge-bottom: unset;"
      >
        ${text}
      </div>
    `;
    },

    addLabel: (productElement, promoLabel, className) => {
        const wrapper = productElement.querySelector(".fs-badges-wrapper");

        if (!wrapper) return;

        const existingLabel = wrapper.querySelector(`.fs-badge-${className}`);

        if (existingLabel) {
            existingLabel.remove();
        }

        wrapper.insertAdjacentHTML("beforeend", promoLabel);
    },
};

// MSA-505: port of the native metaobject-driven badge system onto the FS tile.
// Twin implementations: snippets/pd-card-product-badges.liquid (native Liquid
// cards) and snippets/ma-discount-badges.liquid (Searchspring SERP). Badge
// priority mirrors native: SOLD OUT → inventory_promo (best valid, variant-
// matched) → product_badge (tag-matched, date-gated, all matches) → FINAL SALE
// (product: Discontinued — rendered independently of the others, like native).
// Data arrives via the #fs-badge-data JSON blob (snippets/FSBadgeData.liquid,
// gated by settings.enable_discount_label). Once a card is processed it gets
// .fs-ma-badged, which FSStyle uses to hide the vendor's own sale ribbon — the
// metaobject becomes the single source of truth for badge text AND colours
// (no more per-campaign CSS colour map in FSStyle).
const MetaobjectBadges = {
    // undefined = not read yet; null = blob absent/unparseable (skip injection)
    config: undefined,

    load: () => {
        if (MetaobjectBadges.config !== undefined) return MetaobjectBadges.config;
        const el = document.getElementById("fs-badge-data");
        if (!el) {
            MetaobjectBadges.config = null;
            return null;
        }
        try {
            const parsed = JSON.parse(el.textContent);
            MetaobjectBadges.config = {
                productBadges: Array.isArray(parsed.productBadges) ? parsed.productBadges : [],
                inventoryPromotions: Array.isArray(parsed.inventoryPromotions) ? parsed.inventoryPromotions : [],
            };
        } catch (e) {
            MetaobjectBadges.config = null;
        }
        return MetaobjectBadges.config;
    },

    normalizeTag: (tag) => tag?.toLowerCase().replace(/\s+/g, ""),

    normalizeVariantId: (id) => String(id).replace("gid://shopify/ProductVariant/", ""),

    // Native pd-card-product-badges.liquid treats blank start/end dates as
    // open-ended windows (start-only, end-only, or neither are all valid).
    // NB: the Searchspring twin requires BOTH dates — native semantics win here.
    isDateActive: (startDate, endDate, nowSeconds) => {
        const start = startDate ? Math.floor(Date.parse(startDate) / 1000) : null;
        const end = endDate ? Math.floor(Date.parse(endDate) / 1000) : null;
        if (start !== null && Number.isNaN(start)) return false;
        if (end !== null && Number.isNaN(end)) return false;
        if (start !== null && nowSeconds < start) return false;
        if (end !== null && nowSeconds > end) return false;
        return true;
    },

    // badge_name may carry <font> markup (native renders it raw; FSStyle styles
    // the segment Instrument Serif italic + the master-spacing modifier, same as
    // native card-badge.css) — hence insertAdjacentHTML, matching both twins.
    createBadge: ({label, bgColor, textColor}) => {
        const masterSpacing = typeof label === "string" && label.includes("<font>")
            ? " fs-ma-badge__label--master-spacing"
            : "";
        return `
      <div class="text-badge fs-ma-badge" style="--bg-color: ${bgColor}; --color: ${textColor};">
        <span class="fs-ma-badge__label${masterSpacing}">${label}</span>
      </div>
    `;
    },

    set: (product, productElement) => {
        const config = MetaobjectBadges.load();
        if (!config) return;

        // Same ensure-wrapper logic as NewBadges — the vendor only renders its own
        // .fs-badges-wrapper when it has a ribbon to show, so create one if needed.
        if (productElement.querySelectorAll(".fs-badges-wrapper").length === 0) {
            productElement
                .querySelector(".image-wrapper")
                ?.insertAdjacentHTML("afterbegin", `<div class="fs-badges-wrapper"></div>`);
        }
        const wrapper = productElement.querySelector(".fs-badges-wrapper");
        if (!wrapper) return;

        // Marks the card as metaobject-badged: FSStyle hides the vendor ribbon on
        // these cards only, so a missing/disabled data blob degrades gracefully
        // back to the vendor's own sale ribbon.
        productElement.classList.add("fs-ma-badged");

        // Clear a previous run — FS re-renders the grid on sort/filter changes.
        for (const stale of productElement.querySelectorAll(".fs-ma-badge")) {
            stale.remove();
        }

        const nowSeconds = Math.floor(Date.now() / 1000);
        const tags = (product.tags || []).map(MetaobjectBadges.normalizeTag);
        const badges = [];

        if (product.isSoldOut) {
            // Priority 1 — SOLD OUT suppresses promo/sale badges (native behaviour;
            // colours hardcoded in pd-card-product-badges.liquid the same way).
            badges.push({label: "SOLD OUT", bgColor: "#D3C1B2", textColor: "#222"});
        } else {
            // Priority 2 — best valid inventory promotion for this product's
            // variants: highest percentage wins, RETURN type breaks ties.
            // NB: the Fast Simon product object exposes its variant array as `vra`
            // (each entry keyed by `v_id`), NOT `variants` — the latter reads
            // undefined here and left variantIds empty, so inventory-promotion badges
            // never matched (PLP Inventory Promotion Badge Fix, PR #336). `variants`
            // below (promo.variants) is the theme metaobject's own field — unrelated.
            const variantIds = new Set(
                (product.vra || []).map((v) => String(v.v_id))
            );
            const validPromos = config.inventoryPromotions.filter(
                (promo) =>
                    MetaobjectBadges.isDateActive(promo.start_date, promo.end_date, nowSeconds) &&
                    promo.variants?.some((gid) =>
                        variantIds.has(MetaobjectBadges.normalizeVariantId(gid))
                    )
            );

            if (validPromos.length > 0) {
                validPromos.sort((a, b) => {
                    if (b.percentage !== a.percentage) return b.percentage - a.percentage;
                    if (a.type === "RETURN" && b.type !== "RETURN") return -1;
                    if (b.type === "RETURN" && a.type !== "RETURN") return 1;
                    return 0;
                });
                const best = validPromos[0];
                badges.push({
                    label: best.plp_badge_name,
                    bgColor: best.background_color,
                    textColor: best.text_color,
                });
            } else {
                // Priority 3 — product_badge metaobject: date-gated, tag-matched
                // (exact normalized match, like the Searchspring twin). Discontinued
                // is excluded here — priority 4 renders it independently.
                for (const badge of config.productBadges) {
                    const badgeTag = MetaobjectBadges.normalizeTag(badge.product_tag);
                    if (badgeTag === "product:discontinued") continue;
                    if (!MetaobjectBadges.isDateActive(badge.start_date, badge.end_date, nowSeconds)) continue;
                    if (!tags.includes(badgeTag)) continue;
                    badges.push({
                        label: badge.badge_name,
                        bgColor: badge.background_color,
                        textColor: badge.text_color,
                    });
                }
            }
        }

        // Priority 4 — FINAL SALE always renders for product: Discontinued,
        // independent of sold-out/promo state (native). Label + colours are
        // hardcoded to match the Searchspring twin (client-accepted SERP copy).
        if (tags.includes("product:discontinued")) {
            badges.push({label: "FINAL SALE", bgColor: "#501008", textColor: "#ffffff"});
        }

        for (const badge of badges) {
            wrapper.insertAdjacentHTML("beforeend", MetaobjectBadges.createBadge(badge));
        }
    },
};

// Bridge the Fast Simon SERP heart into the theme's OWN wishlist (MSA-435).
// FS renders its own favourites control (.fs-heart-button-wrapper) on each
// tile, which writes to Fast Simon's favourites store — NOT the theme's
// `ma_wishlist` Cloud Function that /pages/wishlist, the header count, the PDP,
// cart and the Roomvo AR integration all read/write. So anything hearted on an
// FS collection/search grid never appeared on the wishlist page. Rather than
// re-point the wishlist page at FS data (which would desync every other surface
// and break on the Searchspring-backed production grid, and abandon customers'
// existing saved wishlists), we keep `ma_wishlist` as the single source of
// truth: drop FS's heart and inject the theme's own .js-wishlist-cta heart.
//
// The injected heart sits INSIDE FS's product link (.fs-product-image-link),
// so a normal click would open the PDP. The native card sidesteps this by
// placing its heart OUTSIDE the link, but FS owns the tile structure and we
// can't. So we intercept the click in the CAPTURE phase on `document` — the
// earliest point in dispatch, ahead of FS's own card-navigation handler and the
// native anchor default — stop it, and run the add/remove toggle ourselves via
// the theme globals (addProductToWishList / deleteWishlistItemByProductId).
// Stopping propagation also keeps the body-delegated .js-wishlist-cta handler in
// ma-wishlist-js.liquid from double-firing on FS tiles; it still owns native /
// Searchspring cards, whose hearts are NOT inside a .fs-results-product-card.
// FS's own heart is removed here AND hidden in FSStyle (belt-and-braces for grid
// re-renders that re-add it); disabling `serp_enable_favorites` in the FS
// dashboard stops it rendering at all, at which point the removal is a no-op.
const WishlistHeart = {
    // Same 15×13 glyph the native icons.liquid 'wishlist-product' renders and the
    // wishlist page inlines (sections/main-wishlist-template.liquid) — kept as a
    // literal because this static asset can't {% render %} Liquid.
    ICON_SVG: `<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2896 1.11037C12.9378 0.758353 12.52 0.479105 12.0602 0.288584C11.6004 0.0980619 11.1076 0 10.6098 0C10.1121 0 9.61928 0.0980619 9.15947 0.288584C8.69966 0.479105 8.2819 0.758353 7.93004 1.11037L7.19982 1.8406L6.46959 1.11037C5.75887 0.39965 4.79492 0.000368394 3.7898 0.000368401C2.78468 0.000368409 1.82073 0.39965 1.11001 1.11037C0.399281 1.8211 7.4887e-09 2.78505 0 3.79017C-7.4887e-09 4.79528 0.399281 5.75923 1.11001 6.46996L1.84023 7.20018L7.19982 12.5598L12.5594 7.20018L13.2896 6.46996C13.6416 6.1181 13.9209 5.70034 14.1114 5.24053C14.3019 4.78072 14.4 4.28788 14.4 3.79017C14.4 3.29245 14.3019 2.79961 14.1114 2.3398C13.9209 1.88 13.6416 1.46223 13.2896 1.11037V1.11037Z" fill="white"/></svg>`,

    _clickBound: false,

    // One capture-phase listener on `document`, registered on the first processed
    // tile. Capturing at the document root means we see the click before ANY
    // descendant handler (FS's link navigation) and before the native <a> default,
    // whichever mechanism FS uses. Scoped via closest() to injected FS-tile hearts
    // only, so native/Searchspring cards keep going through the body handler.
    bindClickOnce: () => {
        if (WishlistHeart._clickBound) return;
        WishlistHeart._clickBound = true;
        document.addEventListener(
            "click",
            (e) => {
                const cta = e.target.closest(".fs-results-product-card .js-wishlist-cta");
                if (!cta) return;
                e.preventDefault();
                e.stopPropagation();
                WishlistHeart.toggle(cta);
            },
            true
        );
    },

    // Add/remove against ma_wishlist, then let maSyncWishlistIcons re-derive the
    // filled/empty state + header count. Mirrors the collection/search branch of
    // the body-delegated handler (loader spinner, GTM), minus the PDP/cart/Roomvo
    // cases that don't apply on the SERP grid.
    toggle: (cta) => {
        if (typeof addProductToWishList === "undefined") return; // wishlist JS not loaded
        if (cta.dataset.wlBusy === "1") return;                  // in-flight guard
        const icon = cta.querySelector(".wishlist-default-icon");
        const loader = cta.querySelector(".wishlist-loader");
        const productID = cta.dataset.productId;
        const email = window.maCustomerEmail || "";
        const isActive = icon && icon.classList.contains("is-active");

        cta.dataset.wlBusy = "1";
        if (loader) loader.classList.remove("dawn-hidden");
        const done = () => {
            if (loader) loader.classList.add("dawn-hidden");
            cta.dataset.wlBusy = "0";
            if (typeof window.maSyncWishlistIcons === "function") window.maSyncWishlistIcons();
        };

        if (!isActive) {
            addProductToWishList(email, {product_id: productID})
                .then(() => {
                    if (icon) icon.classList.add("is-active");
                    if (typeof sendToGTM === "function") {
                        sendToGTM(productID, window.maWishlistTemplate === "search" ? "search" : "collection");
                    }
                    done();
                })
                .catch(done);
        } else if (typeof deleteWishlistItemByProductId !== "undefined") {
            deleteWishlistItemByProductId(email, productID)
                .then(() => {
                    if (icon) icon.classList.remove("is-active");
                    done();
                })
                .catch(done);
        } else {
            done();
        }
    },

    set: (product, productElement) => {
        WishlistHeart.bindClickOnce();

        // Drop Fast Simon's own favourites heart (its click writes to FS
        // favourites, not ma_wishlist). FSStyle also display:none's it, so a grid
        // re-render that re-adds it before this runs never shows two hearts.
        for (const el of productElement.querySelectorAll(".fs-heart-button-wrapper")) {
            el.remove();
        }

        // Idempotent — FS re-renders tiles on sort/filter/paginate.
        if (productElement.querySelector(".js-wishlist-cta")) return;

        const productID = productElement.dataset.productId;
        if (!productID) return;

        // Inject into the same positioned container FS cornered its heart in
        // (.image-wrapper, position:relative) so FSStyle's top-right/bottom-left
        // positioning resolves against it. Markup mirrors the native card
        // (snippets/pd-card-product-media.liquid) exactly, so wishlist-icon.css's
        // circle + loader styling apply unchanged; the click is owned by the
        // capture-phase listener above, not the body-delegated handler.
        const imageWrapper = productElement.querySelector(".image-wrapper");
        if (!imageWrapper) return;

        imageWrapper.insertAdjacentHTML(
            "beforeend",
            `<div class="product-wishlist-cta js-wishlist-cta" data-product-id="${productID}">
        <div class="product-wishlist-icon">
          <div class="wishlist-default-icon">
            <div class="dawn-hidden wishlist-loader"><span class="wishlist-loader-icon"></span></div>
            ${WishlistHeart.ICON_SVG}
          </div>
        </div>
      </div>`
        );
    },
};

function getProductElements(element) {
    return [...element.querySelectorAll(`.fs-results-product-card`)];
}

function getSecondProductImage(data) {
    if (!data?.attributes) return null;

    const productImagesAttr = data.attributes.find(
        (attr) => attr[0] === "Product images"
    );

    const images = productImagesAttr?.[1];

    if (!Array.isArray(images) || images.length < 2) return null;

    return images[1];
}

function addHoverImageonPLP(productElement, data, reverse = false) {
    const secondImage = getSecondProductImage(data);
    if (!secondImage) return;

    const wrapper = productElement.querySelector(".fs-product-main-image-wrapper");
    const firstImage = wrapper?.querySelector("img");

    if (!wrapper || !firstImage) return;

    wrapper.style.position = "relative";
    wrapper.style.display = "block";
    wrapper.style.overflow = "hidden";

    firstImage.classList.add("fs-first-image");

    const secondImg = document.createElement("img");
    secondImg.src = secondImage;
    secondImg.alt = firstImage.alt;
    secondImg.className = "fs-second-image";
    secondImg.loading = "lazy";
    secondImg.decoding = "async";

    if (reverse) {
        wrapper.classList.add("fs-hover-reverse");
    }

    // Make the hover image clickable
    const link = document.createElement("a");
    link.href = data.productURL;
    link.setAttribute("aria-label", firstImage.alt);
    link.style.position = "absolute";
    link.style.inset = "0";
    link.style.display = "block";

    link.appendChild(secondImg);
    /*wrapper.appendChild(link);*/

    wrapper.appendChild(secondImg);

    syncHoverOverlayToCarousel(wrapper);
}

// The overlay above is only truthful while the tile is showing image #1: it is a
// STATIC copy of PDP image #2 layered over FS's own carousel <img>. Once the
// shopper flicks that carousel (arrow, dot or swipe), the vendor img underneath
// is on an image they chose, so fading the overlay back in on mouse-out would
// show a stale shot. So the overlay is gated on the carousel position: hidden
// (and the vendor img pinned visible) off image #1, restored — hover swap and
// all — the moment the carousel comes back to image #1. FSStyle carries both
// states off .fs-carousel-engaged; .fs-hover-reverse deliberately stays on the
// wrapper throughout, so dropping .fs-carousel-engaged brings the hover
// behaviour back with no second bit of state to keep in sync.
//
// Driven by a MutationObserver rather than click handlers on the controls: the
// vendor lazy-mounts its arrows/dots on first pointer interaction (nothing to
// bind to at hook time), re-renders its <img> on navigation (a captured node
// goes stale), and swipe navigation fires no control click at all. Watching the
// image subtree catches every route into a position change.
//
// "Home" is identified by the IMAGE the carousel is resting on, not by a marker
// index: the vendor's default-selected dot is the LAST one, not the first (its
// slide order puts the product's main image at the end), so any index-based test
// would read the resting state as "already navigated" and suppress the overlay
// permanently. Comparing images sidesteps the ordering entirely.
function syncHoverOverlayToCarousel(wrapper) {
    // Observe the inner .image-wrapper, not `wrapper` — our own class toggle
    // lands on `wrapper`, so this keeps the observer from re-triggering itself.
    // (On the fallback path sync() is idempotent, so it settles either way.)
    const target = wrapper.querySelector(".image-wrapper") || wrapper;

    let homeKey = "";
    let queued = false;

    const sync = () => {
        queued = false;

        const vendorImg = wrapper.querySelector("img.fs-first-image, img.product-image");
        const currentKey = normalizeImageKey(vendorImg?.getAttribute("src"));

        // The first real src we see is the resting position — the image the
        // overlay was built to sit on top of. Captured lazily rather than at
        // hook time because the vendor may still be on a lazy-load placeholder
        // then; until it resolves, currentKey is blank and we stay un-engaged
        // (overlay shown), which is the correct initial state anyway.
        if (!homeKey) homeKey = currentKey;

        wrapper.classList.toggle(
            "fs-carousel-engaged",
            Boolean(currentKey) && currentKey !== homeKey
        );
    };

    const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        // Coalesce: the vendor mutates src + marker classes in the same tick.
        requestAnimationFrame(sync);
    });

    observer.observe(target, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["src", "class"],
    });

    sync();
}

// Shopify serves one asset under many URLs (…_1200x.jpg?v=17 vs …_600x.jpg),
// and the vendor re-renders its <img> on navigation — so identity is the CDN
// path minus the query string and Shopify's _WxH size token, not the raw src.
function normalizeImageKey(src) {
    if (!src) return "";

    let path = src;
    try {
        path = new URL(src, window.location.href).pathname;
    } catch (e) {
        // Odd/relative src the URL parser rejects — compare the raw string.
    }

    return path.replace(/_(\d+x\d*|x\d+)(_crop_\w+)?(?=\.[a-z0-9]+$)/i, "");
}

// MSA-435 (Figma 2026 tile + designer Loom): layer the lifestyle shot (PDP
// image #2) OVER the vendor's own carousel <img> instead of the old inline
// display:none swap. FSStyle positions the overlay (absolute, opacity-fades
// out on card hover ≥990 to reveal the product shot — native pd-card-product
// behaviour). Two reasons the old hide was wrong: (1) no hover swap; (2) the
// vendor RE-RENDERS its img on arrow navigation, silently wiping the inline
// hide and leaving both images stacked in flow (observed on preview theme
// 195450667377). The vendor img stays untouched here, so FS's own carousel
// (arrows/dots) keeps mutating a visible element.
function addHoverSwapSecondImage(productElement, data) {
    // Touch-primary devices (phones/tablets: no hover to swap on) use FS's own
    // swipe carousel for the tile images instead — skip the overlay entirely so
    // the vendor img stays touchable AND the extra lifestyle image is never
    // fetched (a display:none <img> still downloads). Touchscreen laptops keep
    // the overlay: their PRIMARY pointer is a fine hover-capable one, so this
    // query stays false there. FSStyle gates the same rules with the same media
    // query as a belt-and-braces fallback.
    if (window.matchMedia("(hover: none), (pointer: coarse)").matches) return;

    const secondImage = getSecondProductImage(data);
    if (!secondImage) return;

    const imageWrapper = productElement.querySelector(
        ".fs-product-main-image-wrapper .image-wrapper"
    );

    if (!imageWrapper) return;

    const originalImage = [...imageWrapper.querySelectorAll("img.product-image")]
        .find((img) => img.dataset.fsSecondImage !== "true");

    if (!originalImage) return;

    // Avoid adding the second image multiple times
    let secondImageEl = imageWrapper.querySelector('img[data-fs-second-image="true"]');

    if (!secondImageEl) {
        secondImageEl = originalImage.cloneNode(true);

        secondImageEl.classList.add("2-product-image");
        secondImageEl.dataset.fsSecondImage = "true";

        originalImage.insertAdjacentElement("afterend", secondImageEl);
    }

    // Set second image URL
    secondImageEl.src = secondImage;

    // Remove srcset if it exists, so browser uses the new src
    secondImageEl.removeAttribute("srcset");

    // FSStyle scopes the overlay + hover-fade rules to this class, so cards
    // without a second image never get a mispositioned overlay.
    productElement.classList.add("fs-has-second-image");
}


// MSA-435 Figma 2026 "Pop header" (node 5227-15219): a real 24px X — 12px ink
// centred (inset 1/4), stroke #390E09 (Wine 2) at 1.2, round caps — matching
// the design asset exactly. Shared by the desktop drawer's
// .fs-close-filters-button and the mobile sheet's
// .fs-modern-filters-close-button (same design element on both surfaces).
const FS_CLOSE_X_SVG = `
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="#390E09"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

// MSA-435: the outer trigger button (".filters-button-wrapper" /
// ".filters-button-custom-icon-label") is rendered in the SERP top bar, not
// inside either filters surface — query from `document` to reach it. FS
// renders this trigger TWICE (once under .fs-top-container-desktop, once
// under .fs-top-container-mobile, toggled by FS's own internal breakpoint) —
// querySelectorAll+forEach, not querySelector, so both instances get
// relabelled regardless of which one is visible. Called from BOTH hooks: on
// touch devices ≤520px FS lazy-renders the filters sheet only when it is
// first opened, so the serp-filters hook alone would leave the trigger
// reading the vendor default ("Filter & Sort By") until first open — the
// serp-product-grid hook fires with the initial grid render and covers that.
function relabelFilterTriggers() {
    document.querySelectorAll(".filters-button-custom-icon-label").forEach((label) => {
        label.textContent = "REFINE BY";
    });

    document.querySelectorAll(".filters-button-wrapper").forEach((wrapper) => {
        wrapper.setAttribute("aria-label", "Refine By");
    });
}

// MSA-444 (issue #286; sibling #287 restyles the same node's font/colour in
// snippets/FSStyle.liquid:79). The search-page H1 is 100% Fast Simon vendor
// DOM (.fs-search .titleWrapper .title) — FS writes it as ONE text node
// ("Search Results for {query}") with no span around the query term, so the
// theme has no CSS or Liquid hook to add the quotation marks the Live theme
// shows around the searched keyword. Confirmed straight ASCII quotes (") via a
// 5× pixel-crop of .context/msa444-bugs/286/shot-1.png — NOT curly typographic
// quotes (en.default.json's curly-quote result string is a separate, native-
// only sentence and out of scope). Same self-healing vendor-DOM text-swap
// pattern as relabelFilterTriggers() above.
//
// Idempotent by design: the serp-product-grid hook fires on EVERY SERP
// re-render (sort/filter/paginate), so the wrap must never double-apply. Rather
// than a term-substring check (which breaks when FS displays the term in a
// different case than the URL), bail when the matched term is already flanked
// by quote characters — case-independent, and correct whether FS re-writes or
// preserves the title text between renders.
function quoteSearchTitleTerm() {
    const titleEl = document.querySelector(".fs-search .titleWrapper .title");
    // No-op on the collection SERP: FSStyle hides .fs-smart-collection
    // .titleWrapper, and this selector only matches the search surface.
    if (!titleEl) return;

    // Shopify's own native /search?q=... route — URLSearchParams returns the
    // already-URL-decoded term (this static asset can't interpolate Liquid).
    const rawTerm = new URLSearchParams(window.location.search).get("q");
    const term = rawTerm ? rawTerm.trim() : "";
    if (!term) return;

    const text = titleEl.textContent;
    // FS appends the query at the END of "Search Results for {query}", so match
    // the LAST occurrence — a query that equals a prefix word ("for", "results")
    // would otherwise wrap the template word instead of the searched term.
    // Case-insensitive so FS's own casing of the displayed term still matches.
    const idx = text.toLowerCase().lastIndexOf(term.toLowerCase());
    if (idx === -1) return; // FS transformed the term beyond case — leave it alone

    const end = idx + term.length;
    if (text[idx - 1] === '"' && text[end] === '"') return; // already wrapped

    // Preserve FS's own casing of the term via slice (no regex — avoids escaping
    // special characters in arbitrary search terms).
    const matched = text.slice(idx, end);
    titleEl.textContent = `${text.slice(0, idx)}"${matched}"${text.slice(end)}`;
}

// MSA-444 (issue #269). The count VALUE itself ("753" vs Live's "762") comes
// from Fast Simon's own indexed catalogue copy and is explicitly NOT
// theme-fixable (see the issue's pickup-plan comment) — this only rewrites
// the WORDING around whatever number FS reports. FS's vendor default reads
// "{N} results"; the Live (native) theme reads "{N} product" / "{N} products"
// per locales/en.default.json's product_count_simple (singular only when
// N === 1). Same self-healing vendor-DOM text-swap pattern as
// relabelFilterTriggers()/quoteSearchTitleTerm() above.
//
// .fs-num-results renders TWICE simultaneously — once under
// .fs-top-container-desktop, once under .fs-top-container-mobile (only one
// is display:none at a time, per FS's own ~520px internal breakpoint;
// verified live on preview theme 195450667377, /collections/rugs) — so
// querySelectorAll+forEach relabels both regardless of which is visible.
//
// Idempotent by re-deriving from the digits every time rather than checking
// for a prior transform: the hook fires on every sort/filter/paginate
// re-render, and the count itself can change between fires (753 -> 761 after
// a filter), so a "does it already say 'products'" guard would either skip a
// changed value or require re-parsing the old suffix anyway. Rebuilding the
// full string from the current digits is simpler and self-correcting.
function formatResultsCount() {
    document.querySelectorAll(".fs-num-results").forEach((el) => {
        const match = el.textContent.match(/[\d,]+/);
        if (!match) return; // FS text shape changed beyond a plain "{N} results" — leave it alone

        const digits = match[0];
        const count = parseInt(digits.replace(/,/g, ""), 10);
        if (Number.isNaN(count)) return;

        const noun = count === 1 ? "product" : "products";
        el.textContent = `${digits} ${noun}`;
    });
}

// Every tag we can see for a product, normalized the same way
// MetaobjectBadges.normalizeTag does (lowercased, whitespace stripped), merged
// from both sources the FS payload exposes: the friendly `tags` array (the full
// Shopify tag list, e.g. "product: Discontinued") and the "Tag" entry of the
// `attributes` pairs (e.g. "New: Yes"). Neither is guaranteed to carry every
// tag on its own, so union them.
function getFsProductTags(data) {
    const attributes = Array.isArray(data?.attributes) ? data.attributes : [];
    const attributeTags = attributes.find((attr) => attr[0] === "Tag")?.[1] || [];
    const payloadTags = Array.isArray(data?.tags) ? data.tags : [];

    return [...payloadTags, ...attributeTags]
        .filter((tag) => typeof tag === "string")
        .map(MetaobjectBadges.normalizeTag);
}

// Label for the rating slot of a ZERO-review tile (native shows "New" there via
// snippets/okendo-reviews-product-rating-summary.liquid). Only ever called for
// products with no reviews — the caller owns that gate. Precedence, highest
// first:
//   1. "Last Chance"  — carries the "product: Discontinued" tag
//   2. "Stylist Pick" — no "product: Discontinued" tag AND no "new" tag
//   3. "New"          — everything else (i.e. it does carry the "new" tag)
function getZeroReviewLabel(data) {
    const tags = getFsProductTags(data);

    if (tags.includes("product:discontinued")) {
        return "Last Chance";
    }

    // The store tags newness as "New: Yes"; accept a bare "new" tag too.
    const hasNewTag = tags.includes("new:yes") || tags.includes("new");

    return hasNewTag ? "New" : "Stylist Pick";
}

function changeCollectionPageTitleTag() {
    if (!document.body.classList.contains("template-collection")) return;

    const title = document.querySelector(".titleWrapper h1.title");

    if (!title) return;

    const div = document.createElement("div");
    div.className = title.className;
    div.innerHTML = title.innerHTML;

    title.replaceWith(div);
}

function hooks() {
    window.SerpOptions.registerHook("serp-product-grid", ({products, element}) => {
        relabelFilterTriggers();
        quoteSearchTitleTerm();
        formatResultsCount();
        // MSA-444 (#284): re-assert the search breadcrumb after every grid
        // (re-)render so a client-side filter/sort/paginate on the FS
        // search-results surface can't leave it missing. Idempotency-guarded
        // (a no-op when the breadcrumb is already present or the surface isn't
        // a search page), so this is safe to fire on collection SERPs too.
        injectSearchBreadcrumb();
        changeCollectionPageTitleTag();

        for (const productElement of getProductElements(element)) {
            const productID = productElement.dataset.productId;
            const data = products[productID];

            if (typeof data !== "undefined" && data !== null) {
                if (productElement.classList.contains("fs-product-processed")) {
                    continue;
                }

                productElement.classList.add("fs-product-processed");

                /*
                if (window.location.pathname.includes('/search')) {
                  // First image initially, second image on hover.
                  addHoverImageonPLP(productElement, data);
                } else {
                  // Second image initially, first image on hover.
                  addHoverImageonPLP(productElement, data, true);
                }
                */

                addHoverImageonPLP(productElement, data, !hasNoInsituTag(data));

                // MSA-435 Figma 2026 tile "Rating" (node 5224:19570): the
                // count reads "44 REVIEWS" — FS renders a "4.9" average
                // (hidden in FSStyle; no design analog) and a "(86)" count.
                // Rewrite the count text here; FSStyle uppercases/styles it.
                const reviewsCount = productElement.querySelector(".fs-reviews-count");
                if (reviewsCount && !reviewsCount.dataset.fsReformatted) {
                    const countMatch = reviewsCount.textContent.match(/\d+/);
                    if (countMatch) {
                        reviewsCount.textContent =
                            countMatch[0] === "1" ? "1 Review" : `${countMatch[0]} Reviews`;
                        reviewsCount.dataset.fsReformatted = "true";
                    }
                }

                const ratingSummaryHost = productElement.querySelector(".reviews-container");
                if (ratingSummaryHost && !ratingSummaryHost.querySelector(".fs-reviews-summary")) {
                    const reviewsAvg = ratingSummaryHost.querySelector(".fs-reviews-avg");
                    const reviewsCountEl = ratingSummaryHost.querySelector(".fs-reviews-count");
                    const firstPart = reviewsAvg || reviewsCountEl;

                    if (firstPart) {
                        const summary = document.createElement("div");
                        summary.classList.add("fs-reviews-summary");
                        firstPart.parentNode.insertBefore(summary, firstPart);

                        if (reviewsAvg) summary.appendChild(reviewsAvg);
                        if (reviewsCountEl) summary.appendChild(reviewsCountEl);
                    }
                }

                // MSA-444 (#282): the native product card shows a "New" label in
                // the rating slot for products with zero reviews, instead of an
                // empty star row (snippets/okendo-reviews-product-rating-summary
                // .liquid renders <div class="product-zero-reviews-label">New</div>
                // when okendo summaryData.reviewCount == 0; "New" is the theme's
                // product_zero_reviews_label default). FS leaves that slot blank —
                // it renders the .reviews-container but populates NO stars and NO
                // .fs-reviews-count for a zero-review product (verified live: the
                // container is present-but-empty on "Dune/Maplewood/Tandara Round
                // Rug"), so the tile just has dead space where Live shows "New".
                // Mirror native: when the rating row has no stars and no count,
                // inject the same label. Prefer the payload's reviewCount when
                // present (authoritative); fall back to the empty-DOM signal.
                // Idempotent via the .product-zero-reviews-label guard (and the
                // per-product fs-product-processed gate above).
                const ratingRow = productElement.querySelector(".reviews-container");
                if (ratingRow && !ratingRow.querySelector(".product-zero-reviews-label")) {
                    const payloadCount =
                        data && typeof data.reviewCount === "number" ? data.reviewCount : null;
                    const domHasReviews =
                        !!ratingRow.querySelector(".star") || !!ratingRow.querySelector(".fs-reviews-count");
                    const hasNoReviews = payloadCount !== null ? payloadCount === 0 : !domHasReviews;
                    if (hasNoReviews) {
                        const newLabel = document.createElement("div");
                        newLabel.className = "product-zero-reviews-label";
                        newLabel.textContent = getZeroReviewLabel(data);
                        ratingRow.appendChild(newLabel);
                    }
                }

                // add custom badges — run synchronously inside the grid hook
                // (the hook fires once the product element is rendered). A
                // setTimeout here raced grid re-renders and landed badges on
                // detached nodes on fast filter changes.
                NewBadges.set(data, productElement);

                // MSA-505: metaobject-driven badges (SOLD OUT / inventory
                // promos / product_badge / FINAL SALE) — see module above.
                MetaobjectBadges.set(data, productElement);

                // MSA-435: swap FS's own favourites heart for the theme's
                // .js-wishlist-cta heart wired to ma_wishlist — see module above.
                WishlistHeart.set(data, productElement);


                // Check for the compare-container and move its value under the price-container only if not already added
                const compareElement = productElement.querySelector(".compare-container .compare");
                const priceContainer = productElement.querySelector(".price-container .price");

                // Check if the compare value is not already appended
                if (compareElement && priceContainer && !productElement.querySelector(".compare-price")) {
                    const compareValue = compareElement.textContent.trim();

                    // Create a new div element to append the compare value under the price
                    const comparePriceDiv = document.createElement("div");
                    comparePriceDiv.classList.add("compare-price");
                    comparePriceDiv.textContent = compareValue;
                    priceContainer.appendChild(comparePriceDiv); // Append the compare value under the price

                    // MSA-435: native shows current price first, compare-at price
                    // second — but FS finishes writing its own "From $X" price
                    // text into priceContainer AFTER this hook runs, so a single
                    // appendChild here lands compare-price BEFORE that text
                    // (confirmed empirically: priceContainer was still empty at
                    // this point). A one-shot re-append can't win that race
                    // reliably, so keep compare-price pinned as the LAST child
                    // for as long as FS keeps mutating this specific price
                    // element — self-correcting instead of timing-dependent.
                    new MutationObserver(() => {
                        if (priceContainer.lastChild !== comparePriceDiv) {
                            priceContainer.appendChild(comparePriceDiv);
                        }
                    }).observe(priceContainer, {childList: true});
                }

                const attributes = data.attributes || [];

                // Find "Global.type plp filter"
                const typeAttribute = attributes.find(
                    (attr) => attr[0] === "Global.badges"
                );

                if (typeAttribute && Array.isArray(typeAttribute[1])) {
                    // Keep every merchant badge; reverse a copy without mutating the payload.
                    const labels = typeAttribute[1].slice().reverse();

                    // Avoid adding labels more than once
                    if (!productElement.querySelector(".fs-card-product__labels")) {
                        const labelsWrapper = document.createElement("div");
                        labelsWrapper.classList.add("fs-card-product__labels");

                        labels.forEach((label) => {
                            const labelElement = document.createElement("div");
                            labelElement.classList.add("fs-card-product__label");

                            const span = document.createElement("span");
                            span.textContent = label;

                            labelElement.appendChild(span);
                            labelsWrapper.appendChild(labelElement);
                        });

                        const infoContainer = productElement.querySelector(".info-container");

                        if (infoContainer) {
                            infoContainer.appendChild(labelsWrapper);
                        }
                    }
                }
            }
        }

        // MSA-435: reflect ma_wishlist membership onto the freshly-injected
        // hearts (filled state for products already saved). Defined in
        // snippets/ma-wishlist-js.liquid and exposed on window; guarded because
        // that script loads independently of this one. Re-runs on every grid
        // (re-)render so sort/filter/paginate keep the hearts in sync.
        if (typeof window.maSyncWishlistIcons === "function") {
            window.maSyncWishlistIcons();
        }
    });

    window.SerpOptions.registerHook("serp-filters", ({facets, element}) => {
        // Desktop drawer elements (.filters-modal surface)
        const closeButton = element.querySelector(".fs-close-filters-button");
        const filtersTitle = element.querySelector(".fs-filters-title-text");
        // Mobile "Filter & Sort" sheet elements (.fs-modern-filters-container
        // surface — FS renders it instead of the desktop drawer on touch
        // devices at ≤520px viewports; `element` IS that container there, and
        // this hook re-fires on every render of it, so these swaps self-heal
        // when FS re-renders the sheet).
        const modernTitle = element.querySelector(".fs-modern-filters-title-text");
        const modernClose = element.querySelector(".fs-modern-filters-close-button");
        const modernClearAll = element.querySelector(".fs-modern-mobile-filters-clear-all-button");

        relabelFilterTriggers();
        // MSA-444 (#269): a facet toggle re-renders this hook AND changes the
        // result count — same dual-registration rationale as
        // relabelFilterTriggers() above (belt-and-braces alongside the
        // serp-product-grid hook's own call).
        formatResultsCount();

        if (filtersTitle) {
            // MSA-435 Figma 2026 "Pop header" (node 5227-15219): the drawer
            // titles itself "Refine By" (the componentized design; the round-1
            // raster mock showing "Filter By" was a screenshot of the FS vendor
            // default, not design intent).
            filtersTitle.textContent = "Refine By";
        }

        if (modernTitle) {
            // Same "Pop header" spec — the mobile sheet's vendor default is
            // "Filter & Sort".
            modernTitle.textContent = "Refine By";
        }

        if (modernClose) {
            modernClose.innerHTML = FS_CLOSE_X_SVG;
        }

        if (modernClearAll) {
            // MSA-435 Figma 2026 footer ("ATC Button" node 5227-15224): the
            // design labels this "Clear All"; the vendor default is "Clear".
            modernClearAll.textContent = "Clear All";
        }

        // Mobile price facet: the vendor's currency prefix renders "$."
        // (symbol + a money-format artefact); the design pill (node
        // 5227:2853) shows the bare symbol. Strip only a trailing dot so
        // other stores' currency symbols pass through untouched.
        element.querySelectorAll(".input-currency-symbol").forEach((sym) => {
            sym.textContent = sym.textContent.trim().replace(/\.$/, "");
        });

        if (!closeButton) return;

        // No CSS rotate needed (FSStyle's old rotate-45 rule for the previous
        // "+" icon is removed).
        closeButton.innerHTML = FS_CLOSE_X_SVG;

        element.querySelectorAll(".category-items").forEach((categoryItems) => {
            let scrollTop = categoryItems.scrollTop;

            categoryItems.addEventListener("scroll", () => {
                scrollTop = categoryItems.scrollTop;
            });

            const observer = new MutationObserver(() => {
                requestAnimationFrame(() => {
                    categoryItems.scrollTop = scrollTop;
                });
            });

            observer.observe(categoryItems, {
                childList: true,
                subtree: true,
                attributes: true
            });
        });
    });
}

// MSA-444 (#285): restore the "Home • Search Results" breadcrumb on the
// /search page. On this FS-active path templates/search.json disables the
// native `main` section (main-search) and renders the FS app via custom_liquid
// → isp-smart-navigation-ssr.liquid, and FS renders the whole heading client-
// side inside #fast-simon-serp-app with no theme markup slot — so unlike
// templates/collection.json (which has a main-collection-banner section that
// renders pd-breadcrumbs), search has no server-rendered breadcrumb anywhere.
// The breadcrumb is page CHROME owned by the theme, NOT a vendor SERP control,
// so injecting it above the FS app container is restyle-not-fabricate-compliant.
//
// MSA-444 (#284): the breadcrumb must also live on /pages/search-results.
// Fast Simon client-routes to that Page whenever a filter/sort/paginate is
// applied (its settings.path, wired into the FS gate in layout/theme.liquid),
// and a hard reload of the filtered URL lands there directly. That Page uses
// the `page` template, so body carries `template-page`, NOT `template-search`
// (layout/theme.liquid:391 derives the class from the template name) — the
// old `template-search`-only guard rejected it, so the breadcrumb vanished
// after any filter/sort/reload (confirmed live: /pages/search-results renders
// the FS SERP but had no .pd-search-breadcrumb). Broaden the guard to any FS
// SERP page carrying the search context: template-search OR a `page` template
// that mounts #fast-simon-serp-app. Collection pages are template-collection
// (their own native breadcrumb) so they're excluded; ordinary content pages
// have no #fast-simon-serp-app so they're excluded too.
//
// #fast-simon-serp-app is server-rendered HTML present before this deferred
// script runs, and is only innerHTML-cleared/rehydrated — never replaced
// (isp-smart-navigation-ssr.liquid) — so a beforebegin insert of a SIBLING is
// stable across FS re-renders (clearing the app's innerHTML can't touch a
// preceding sibling). This runs once on load AND from the serp-product-grid
// hook (idempotency-guarded) so it self-heals if FS ever re-renders past the
// sibling on a client-side filter/sort/paginate.
function injectSearchBreadcrumb() {
    const serpApp = document.getElementById("fast-simon-serp-app");
    if (!serpApp) return; // no FS SERP here → nothing to anchor a breadcrumb to

    // Search surfaces that carry the "Search Results" breadcrumb: /search
    // (template-search) and /pages/search-results (template-page + FS SERP; the
    // FS filter/sort/paginate destination — #284). See the block comment above.
    const isSearchSurface =
        document.body.classList.contains("template-search") ||
        document.body.classList.contains("template-page");
    if (!isSearchSurface) return;

    // Idempotency guard — never inject twice.
    if (document.querySelector(".pd-search-breadcrumb")) return;

    // Resolve Home from the header logo link (routes.root_url, server-rendered
    // above <main> and present before this deferred script runs) so multi-market
    // subfolder installs get their own root rather than a hardcoded "/".
    const homeHref =
        document.querySelector(".header__heading-link")?.getAttribute("href") || "/";

    // Reuse the theme's EXISTING breadcrumb component classes
    // (snippets/pd-breadcrumbs.liquid markup + frontend/legacy/styles/snippets/
    // pd-breadcrumbs.css, loaded on every page in @layer legacy) so styling
    // (dot separator, muted current-page link) comes for free. "Search Results"
    // (both words capitalised) matches the live theme verbatim (QC shot-1.png),
    // NOT the lowercase templates.search.title locale value. homeHref is theme-
    // controlled (routes.root_url), not user input — no injection surface.
    serpApp.insertAdjacentHTML(
        "beforebegin",
        `<div class="pd-search-breadcrumb page-width">
          <nav class="breadcrumbs" role="navigation" aria-label="breadcrumbs">
            <ol class="breadcrumbs__list">
              <li class="breadcrumbs__item">
                <a class="breadcrumbs__link" href="${homeHref}">Home</a>
              </li>
              <li class="breadcrumbs__item">
                <a class="breadcrumbs__link" aria-current="page">Search Results</a>
              </li>
            </ol>
          </nav>
        </div>`
    );
}

// execution here — register the listener unconditionally AND run immediately
// if SerpOptions is already present, with an idempotency guard. This avoids
// the race where the async SERP bundle dispatches 'fast-serp-ready' before
// this deferred script attaches its listener (event missed), or where
// SerpOptions is set after this runs (immediate call would no-op and the
// listener catches it).
let fsHooksInitialised = false;

function initFsHooks() {
    if (fsHooksInitialised || !window.SerpOptions) return;
    fsHooksInitialised = true;
    hooks();
}

window.addEventListener('fast-serp-ready', initFsHooks);
initFsHooks();

// The breadcrumb is independent of the FS SERP bundle — run it once, now.
injectSearchBreadcrumb();
